const baseClass = 'page-header__content-nav';

function getPetrolNavigation() {
  const navigation = document.getElementsByClassName(baseClass);
  if (navigation == null || navigation.length <= 0) {
    return null;
  }

  return navigation[0];
}

function onIntersect(event) {
  const [ entry ] = event;
  const { target } = entry;

  setPetrolNavigationVisible(entry.isIntersecting === false && target.getBoundingClientRect().top < 50);
}

export function setPetrolNavigationVisible(visible) {
  const navigation = getPetrolNavigation();
  if (navigation == null) {
    console.warn("Unable to find petrolnavigation on page. Aborting.");

    return;
  }

  if (visible) {
    navigation.classList.add(`${baseClass}--is-visible`);
  } else {
    navigation.dispatchEvent(new CustomEvent('close-dropdowns', {
      bubbles: true,
    }));

    navigation.classList.remove(`${baseClass}--is-visible`);
  }
}


function init() {
  const navigation = getPetrolNavigation();
  if (navigation == null) {
    return;
  }

  const desktopNavigation = document.querySelector('.page-wrap .nav.nav-pills');
  if (desktopNavigation == null) {
    return;
  }

  const observer = new IntersectionObserver(
    onIntersect,
    {
      root: null,
      threshold: 0,
      rootMargin: '-42px 0px 0px 0px',
    });

  observer.observe(desktopNavigation);
}

export default {
  init,
};
